const InputField = ({ label, id, type = 'text', value, onChange, required = false, ...props }) => (
  <div className="space-y-2">
    <label
      htmlFor={id}
      className="flex items-center text-sm font-medium text-foreground-muted font-inter"
    >
      {label}
      {required && <span className="text-error-900 ml-1">*</span>}
    </label>
    <input
      type={type}
      id={id}
      name={id}
      value={value}
      onChange={onChange}
      required={required}
      className="block w-full h-10 px-3 py-2 bg-secondary-50 border border-gray-200 rounded-md text-sm font-medium text-foreground font-inter placeholder:text-gray-400 focus:outline-none focus:border-secondary-600 focus:ring-1 focus:ring-secondary-600/20 transition-colors"
      {...props}
    />
  </div>
)

export default InputField
